import { createColumnHelper } from "@tanstack/react-table";
import { IEstablishmentLogLevel } from "../../models/EstablishmentLogLevel";
import { usePermissionCheck } from "../../app/common/helper/Permissions";
import { Permissions } from "../../app/enums";
import { NavLink } from "react-router-dom";
import SimpleTable from "../../components/simpletable";

interface ILogLevelEstablishmentsTableRow extends IEstablishmentLogLevel {
  searchableText: string;
}

export interface ILogLevelEstablishmentsProps {
  data: IEstablishmentLogLevel[];
  isLoading: boolean;
}

export default function LogLevelEstablishments(props: ILogLevelEstablishmentsProps) {
  const columnHelper = createColumnHelper<ILogLevelEstablishmentsTableRow>();

  let CanViewEstablishments: boolean = usePermissionCheck(Permissions.CanViewEstablishments);

  const columns = [
    columnHelper.display({
      id: 'rowNumber',
      header: () => <span style={{ width: '15px', display: 'block' }}>#</span>,
      size: 1,
      minSize: 1,
      maxSize: 1,
      cell: ({ row }) => (
        <div className="short-text" style={{ width: '15px' }}>
          <span>{row.index + 1}</span>
        </div>
      ),
    }),
    columnHelper.accessor('establishmentName', {
      header: () => <span>Establishment</span>,
      size: 15,
      minSize: 15,
      maxSize: 15,
      cell: ({ row }) => (
        <div className="long-text" title={row.original.establishmentName as string}>
          {
            CanViewEstablishments && row.original.establishmentID ?
              <NavLink to={`/establishment/${row.original.establishmentID}`}>
                {row.original.establishmentName}
              </NavLink>
              :
              row.original.establishmentName
          }
        </div>
      ),
    }),
    columnHelper.accessor('deviceName', {
      header: () => <span>Device</span>,
      size: 12,
      minSize: 12,
      maxSize: 12,
      cell: ({ row }) => (
        <div className="short-text" title={row.original.deviceName as string}>
          <span>{row.original.deviceName}</span>
        </div>
      ),
    }),
    columnHelper.accessor('productName', {
      header: () => <span>Product</span>,
      size: 12,
      minSize: 12,
      maxSize: 12,
      cell: ({ row }) => (
        <div className="short-text" title={row.original.productName as string}>
          <span>{row.original.productName}</span>
        </div>
      ),
    }),
    columnHelper.accessor('packageName', {
      header: () => <span>Package</span>,
      size: 12,
      minSize: 12,
      maxSize: 12,
      cell: ({ row }) => (
        <div className="short-text" title={row.original.packageName as string}>
          <span>{row.original.packageName}</span>
        </div>
      ),
    }),
    columnHelper.accessor('trace', {
      header: () => <span>Trace</span>,
      size: 8,
      minSize: 8,
      maxSize: 8,
      cell: ({ row }) => (
        <div className="short-text">
          <span>{row.original.trace.toLocaleString()}</span>
        </div>
      ),
    }),
    columnHelper.accessor('debug', {
      header: () => <span>Debug</span>,
      size: 8,
      minSize: 8,
      maxSize: 8,
      cell: ({ row }) => (
        <div className="short-text">
          <span>{row.original.debug.toLocaleString()}</span>
        </div>
      ),
    }),
    columnHelper.accessor('information', {
      header: () => <span>Information</span>,
      size: 10,
      minSize: 10,
      maxSize: 10,
      cell: ({ row }) => (
        <div className="short-text">
          <span>{row.original.information.toLocaleString()}</span>
        </div>
      ),
    }),
    columnHelper.accessor('total', {
      header: () => <span>Total</span>,
      size: 8,
      minSize: 8,
      maxSize: 8,
      cell: ({ row }) => (
        <div className="short-text">
          <span>{row.original.total.toLocaleString()}</span>
        </div>
      ),
    }),
  ];

  return (
    <div className="top-messages-table">
      <SimpleTable
        tableKey={"log-level-establishments-table"}
        columns={columns}
        data={props.data}
        isLoading={props.isLoading}
      />
    </div>
  );
}
